import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  PERIODOS_RESUMO_NOTIFICACAO,
  PeriodoResumoNotificacao,
} from "@/types/notificacao-log.type";

export function PeriodoResumoSelect({
  value,
  onChange,
}: {
  value: PeriodoResumoNotificacao;
  onChange: (dias: PeriodoResumoNotificacao) => void;
}) {
  return (
    <Select
      value={String(value)}
      onValueChange={(v) => onChange(Number(v) as PeriodoResumoNotificacao)}
    >
      <SelectTrigger className="w-[160px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {PERIODOS_RESUMO_NOTIFICACAO.map((periodo) => (
          <SelectItem key={periodo} value={String(periodo)}>
            Últimos {periodo} dias
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
